
import React, { useState } from 'react'
import logo from "../../assets/authlogo.png"
import { Link, useLocation } from "react-router-dom"
import { Accordion, Card, Button } from "react-bootstrap";
import "./Sidebar.css"
import { useSelector } from 'react-redux';

function Sidebar() {
  const location = useLocation();
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [openIndex, setOpenIndex] = useState(null);
  const sidebarItems =[
        { name: currentLocal.home.dashboard, path: "dashboard", activePaths: ["dashboard"] },
            { name: currentLocal.home.categories, path: "categories", activePaths: ["categories"] },
    { name: currentLocal.home.products, path: "products", activePaths: ["products"] },
    { name: currentLocal.home.orders, path: "orders", activePaths: ["orders","order"] },
    { name: currentLocal.home.users, path: "users", activePaths: ["users","user"] },
    { name: currentLocal.home.banners, path: "banners", activePaths: ["banners"] },

  ]
const isRouteActive = (activePaths = []) => {
  const currentPath = location.pathname.toLowerCase();

  return activePaths.some(
    (path) =>
      currentPath === `/dashboard/${path}` ||
      currentPath.startsWith(`/dashboard/${path}/`)
  );
};






  return (
    <div className="sidebar_container">
      <div className="logo_container">
        <img src={logo} alt="" className='w-75 h-75' />
      </div>
      <div className="link_container">
        <ul className="p-0 m-0">
          {sidebarItems && sidebarItems.map((item, index) => {

            const isOpen = openIndex === index; // check if this dropdown is open

            return (
              item.subTabs ? (
                <div className="d-flex flex-column text-white p-2" key={index}>
                  <Button
                    className="nav_item border-0"
                    onClick={() =>
                      setOpenIndex(isOpen ? null : index) // toggle only this one
                    }
                  >
                    <p className="mb-0 pe-4">{item.name}</p>
                    {isOpen ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor"
                        className="bi bi-chevron-up" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 
                          5.647a.5.5 0 0 1-.708-.708z" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor"
                        className="bi bi-chevron-down" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 
                          .708 0L8 10.293l5.646-5.647a.5.5 
                          0 0 1 .708.708l-6 6a.5.5 0 0 
                          1-.708 0l-6-6a.5.5 0 0 1 
                          0-.708" />
                      </svg>
                    )}
                  </Button>

                  {isOpen && (
                    <Accordion defaultActiveKey="0" className="w-100">
                      <Card className="bg-transparent border-0">
                        <Accordion.Collapse eventKey="0">
                          <div className="d-flex flex-column ps-3">
                            {item.subTabs.map((tabitem, subIndex) => {

                              return (
                                <div
                                  key={subIndex}
                                  className={isRouteActive(item.activePaths) ? "nav_item active" : "nav_item"}

                                >
                                  <Link
                                    className="text-start border-0 w-100"
                                    to={`/dashboard/${tabitem.path ? tabitem.path : tabitem.name.toLowerCase()
                                      }`}
                                  >
                                    ● {tabitem.name}
                                  </Link>
                                </div>
                              )
                            })}
                          </div>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                  )}
                </div>
              ) : item.path === "tarteeb" ? (
                <li
                  key={index}
                  className={isRouteActive(item.activePaths) ? "nav_item active" : "nav_item"}

                >
                  <a href="https://taarteb.com/" target="_blank" rel="noopener noreferrer">
                    <span className="mx-2">{item.name}</span>
                  </a>
                </li>
              ) : (
                <li
                  key={index}
                  className={isRouteActive(item.activePaths) ? "nav_item active" : "nav_item"}

                >
                  <Link to={`/dashboard/${item.path ? item.path : item.name.toLowerCase()}`}className='w-100'>
                    <span className="mx-2 w-100">{item.name}</span>
                  </Link>
                </li>
              )
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default Sidebar
